import React, { useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider, Grid, Button } from "@mui/material";
// import headImg from "../../../Assets/head.erp.jpg"
import noProfileImg from "../../../Assets/noProfileImg.png"


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

const AboutUs = () => {



    const ErpDevelopmentTeam = [
        {
            name: "Lokesh",
            role: "HEAD ERP",
            profile: null
        },
        {
            name: "Ramesh sankar",
            role: "UI ERP HO",
            profile: null
        },
        {
            name: "Pravin kumar",
            role: "UI ERP HO",
            profile: null
        },
        {
            name: "Vallarasu",
            role: "ADBA",
            profile: null
        },
    ]



    return (
        <Box>
            <Box>
                <ProfileContainer p={{ xs: 0 }} mb={2} >
                    <Container maxWidth="lg" >
                        <ResponsiveBox mt={2}>
                            <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                <Typography variant="h6" gutterBottom>About Us</Typography>
                                <Divider />
                                <Typography variant="h5" gutterBottom color='black' mt={3}>ERP Development Team</Typography>
                                <Grid container spacing={2} mt={3}>
                                    {ErpDevelopmentTeam.map((data, index) => (
                                        <Grid item size={{ md: 3, xs: 12, sm: 6 }} >
                                            <Box sx={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                boxShadow: 3
                                            }}>
                                                <Box component="img" src={data.profile || noProfileImg} sx={{
                                                    width: "100%",
                                                    height: "300px "
                                                }} />
                                                <Box sx={{
                                                    padding: "10px"
                                                }}>
                                                    <Typography variant="h6" gutterBottom sx={{
                                                        color: "#007bff"
                                                    }}>{data.name}</Typography>
                                                    <Typography variant="span" gutterBottom sx={{
                                                        color: "#00d8c8",
                                                        backgroundColor: "rgba(0, 216, 200, .09)",
                                                        padding: "4px"
                                                    }}>{data.role}</Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Paper>
                        </ResponsiveBox>
                    </Container>
                </ProfileContainer>
            </Box>

        </Box>
    )
}

export default AboutUs